// Apart from the `interpolate` of `errors.ts` and `field-errors.ts` on purpose: those take
// `ProblemParams`, which admit null and nesting. See apps/frontend/docs/layer-messaggi-tre-parti.md

/** The values a component can interpolate: no `null`, no nesting. */
export type InterpolationValues = Readonly<Record<string, string | number>>

/** Replaces `{key}` with its value. An unmatched placeholder **stays in the text**: it
 * shows up in QA instead of shipping a mutilated sentence. */
export function interpolate(text: string, values: InterpolationValues): string {
  return text.replace(/\{(\w+)\}/g, (placeholder, key: string) => {
    // hasOwn rather than a direct lookup: `{toString}` would resolve to a function on the
    // prototype, and the sentence would show source code to a user.
    if (!Object.hasOwn(values, key)) return placeholder
    return String(values[key])
  })
}

/** The words on either side of `{key}`, for a sentence one of whose parts a component draws
 *  apart: the order stays the catalogue's, so a language that puts the part first still can.
 *  A text without the placeholder comes back whole in `before`. */
export function splitAtPlaceholder(
  text: string,
  key: string,
): { readonly before: string; readonly after: string } {
  const at = text.indexOf(`{${key}}`)
  if (at === -1) return { before: text, after: '' }
  return { before: text.slice(0, at), after: text.slice(at + key.length + 2) }
}
